import { useTypedReactFlow } from '../../../hooks/use-react-flow'
import type { GenericEdge, GenericNode } from '../../../types'
import { executeEval } from '../utils'

/**
 * Hook that provides a function to start/restart eval with current nodes and edges
 */
export const useStartEval = () => {
  const { getNodes, getEdges } = useTypedReactFlow()

  const startEval = (options?: { evalId?: string | null }) => {
    const currentNodes = getNodes() as GenericNode[]
    const currentEdges = getEdges() as GenericEdge[]

    executeEval({
      nodes: currentNodes,
      edges: currentEdges,
      evalId: options?.evalId ?? null,
    })
  }

  return startEval
}
